var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsEnum, IsNumber, IsOptional, ValidateNested } from 'class-validator';
import { VehicleModelFeeCalculationMethod } from '../../../../enums';
import { CreateDayFeeDto } from './create-day-fee.dto';
import { CreateFeeWeekendPolicyDto } from './create-fee-weekend-policy.dto';
import { OfferedDayFeeDto } from '../../offered-fee.dto';
export class CreateFeeInfoDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateFeeInfoDto.prototype, "vehicleModelId", void 0);
__decorate([
    IsEnum(VehicleModelFeeCalculationMethod),
    __metadata("design:type", String)
], CreateFeeInfoDto.prototype, "calculationMethod", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateFeeWeekendPolicyDto),
    __metadata("design:type", CreateFeeWeekendPolicyDto)
], CreateFeeInfoDto.prototype, "applyWeekendPolicyOn", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateDayFeeDto),
    __metadata("design:type", CreateDayFeeDto)
], CreateFeeInfoDto.prototype, "basic", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => OfferedDayFeeDto),
    __metadata("design:type", OfferedDayFeeDto)
], CreateFeeInfoDto.prototype, "offered", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateDayFeeDto),
    __metadata("design:type", CreateDayFeeDto)
], CreateFeeInfoDto.prototype, "option1", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateDayFeeDto),
    __metadata("design:type", CreateDayFeeDto)
], CreateFeeInfoDto.prototype, "option2", void 0);
